module.exports = __webpack_public_path__ + "img/140.7.71193399.png";